<template>
  <router-view />
</template>
<script>
export default {
  created() {
    this.$store.dispatch("initAppBridge");
  }
};
</script>

<style lang="scss"></style>
